import { PromptProfileService } from '../services/prompt-profile.service';
import { IAiModel } from '../types/IAiModel';

export class AiUtil {
  private static modelProvider: Map<string, IAiModel[]> = new Map([
    ['gpt-4o-mini', [{ model: 'kyloe-ai-4o-mini', provider: 'AZURE' }]],
    ['gpt-4-turbo', [{ model: 'kyloe-ai-gpt4', provider: 'AZURE' }]],
    [
      'gpt-4.1',
      [
        { model: 'kyloe-ai-41', provider: 'AZURE', id: 'AZURE-GPT-41' },
        { model: 'kyloe-DT-41', provider: 'AZURE', id: 'AZURE-DT-41' },
      ],
    ],
    [
      'gpt-4o',
      [
        { model: 'kyloe-ai-4o', provider: 'AZURE', id: 'AZURE-GPT-4o' },
        { model: 'kyloe-DT', provider: 'AZURE', id: 'AZURE-DT' },
      ],
    ],
    ['sonnet-4', [{ model: 'anthropic.claude-sonnet-4-20250514-v1:0', provider: 'BEDROCK' }]],
    [
      'claude-3.5-sonnet',
      [{ model: 'anthropic.claude-3-5-sonnet-20240620-v1:0', provider: 'BEDROCK' }],
    ],
    [
      'claude-3-haiku',
      [{ model: 'anthropic.claude-3-haiku-20240307-v1:0', provider: 'BEDROCK' }],
    ],
    ['nova-micro', [{ model: 'nova-micro', provider: 'BEDROCK' }]],
  ]);

  public static updateModelNames(models: string[]): string[] {
    return models.map((model) => {
      const mapping = PromptProfileService.modelList.find((m) => m.oldModel === model);
      return mapping ? mapping.newModel : model;
    });
  }
  public static getModelByName(name: string): IAiModel | undefined {
    const modelName = this.updateModelNames([name])[0];
    const models = this.modelProvider.get(modelName);
    return models ? models[0] : undefined;
  }

  public static getModelById(type: string, id: string): IAiModel | undefined {
    const models = this.modelProvider.get(type);
    return models?.find((model) => model.id && model.id === id);
  }

  public static setModelProvider(name: string, model: IAiModel): void {
    const models = this.modelProvider.get(name) || [];
    models.push(model);
    this.modelProvider.set(name, models);
  }
}
